module.exports = __webpack_public_path__ + "static/media/crossword-social.2e4beb9a.png";